import { platformComparison } from '@/mocks/content';

export default function PlatformComparison() {
  return (
    <section id="platform-comparison" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            高清中文字幕日韩平台对比
          </h2>
          <p className="text-foreground-600 text-sm max-w-[550px] mx-auto">
            六大主流平台横评，从字幕质量、更新速度、内容覆盖多维度帮你选择最佳观看平台
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-[900px]">
            <div className="grid grid-cols-7 gap-0 bg-background-200/50 rounded-t-xl overflow-hidden">
              <div className="p-4 font-semibold text-sm text-foreground-700">平台</div>
              <div className="p-4 font-semibold text-sm text-foreground-700">字幕速度</div>
              <div className="p-4 font-semibold text-sm text-foreground-700">字幕质量</div>
              <div className="p-4 font-semibold text-sm text-foreground-700">支持语言</div>
              <div className="p-4 font-semibold text-sm text-foreground-700">日韩内容</div>
              <div className="p-4 font-semibold text-sm text-foreground-700">价格</div>
              <div className="p-4 font-semibold text-sm text-foreground-700">备注</div>
            </div>

            {platformComparison.map((platform) => (
              <div
                key={platform.name}
                className={`grid grid-cols-7 gap-0 border-b border-background-200/50 ${
                  platform.highlight ? 'bg-accent-50/50' : 'bg-background-50'
                }`}
              >
                <div className="p-4 flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${platform.logo} text-foreground-700`}></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {platform.name}
                  </span>
                  {platform.highlight && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                      推荐
                    </span>
                  )}
                </div>
                <div className="p-4 text-sm text-foreground-700 flex items-center">
                  {platform.subtitleSpeed}
                </div>
                <div className="p-4 text-sm text-foreground-700 flex items-center">
                  {platform.subtitleQuality}
                </div>
                <div className="p-4 text-sm text-foreground-600 flex items-center">
                  {platform.subtitleLanguages}
                </div>
                <div className="p-4 text-sm text-foreground-700 flex items-center">
                  {platform.contentVolume}
                </div>
                <div className="p-4 text-sm text-foreground-700 flex items-center">
                  {platform.price}
                </div>
                <div className="p-4 text-xs text-foreground-600 flex items-center">
                  {platform.note}
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-foreground-500 mt-4 text-center">
          数据更新于 2024年8月，各平台价格和内容可能随时调整
        </p>
      </div>
    </section>
  );
}